import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import "./App.css";
import { firebase, firebaseApp } from "./Firebase";
import "firebase/auth";
import withFirebaseAuth from "react-with-firebase-auth";
import MainPageWrapper from "./pages/MainPage/MainPageWrapper";
import SiteDetailPage from "./pages/SiteDetailPage/SiteDetailPage";
import Header from "./components/Header/Header";
import { PrivateRoute } from "./components/PrivateRoute/PrivateRoute";
import { runAnalytics } from "./utils";

const firebaseAppAuth = firebaseApp.auth();
const providers = {
  googleProvider: new firebase.auth.GoogleAuthProvider()
};

const authConfig = {
  google: {
    returnAccessToken: true, // Returns an access token as googleAccessToken prop
    saveUserInDatabase: true // Saves user in database at /users ref
  }
};

function App() {
  const [isSignedIn, setIsSignedIn] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    firebase.auth().onAuthStateChanged(user => {
      const authSignIn = () => {
        setIsSignedIn(true);
        setCurrentUser(user);
      };

      if (user) {
        authSignIn();
      }
    });
  });

  useEffect(() => {
    if (currentUser && runAnalytics({ userEmail: currentUser.email, window })) {
      window.analytics.identify("Signin", {
        name: currentUser.displayName,
        email: currentUser.email
      });
    }
  }, [currentUser]);

  const signOut = () => {
    firebase.auth().signOut();
    setIsSignedIn(false);

    if (runAnalytics({ userEmail: currentUser.email, window })) {
      window.analytics.identify("Signout", {
        name: currentUser.displayName,
        email: currentUser.email
      });
    }
  };

  return (
    <>
      <div className="app-container">
        <Header signOut={signOut} isSignedIn={isSignedIn} />

        <div className="page-container">
          <Router>
            <Switch>
              <PrivateRoute
                path="/:url"
                component={SiteDetailPage}
                currentUser={currentUser}
                isSignedIn={isSignedIn}
                firebase={firebase}
              />
              <PrivateRoute
                path="/"
                component={MainPageWrapper}
                currentUser={currentUser}
                isSignedIn={isSignedIn}
                firebase={firebase}
              />
            </Switch>
          </Router>
        </div>
      </div>
    </>
  );
}

export default withFirebaseAuth({
  providers,
  firebaseAppAuth,
  authConfig
})(App);
